import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataResponse, SocialWallModel, SocialWallPostModel } from '../models';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class SocialWallApiService {

  private readonly httpService = inject(HttpService);

  public getSocialWallChannels(): Observable<DataResponse<SocialWallModel>> {
    return this.httpService.get('social-walls');
  }

  public getSocialWallPosts(id: string, queryParams: any = {}): Observable<DataResponse<SocialWallModel>> {
    const params = new HttpParams({ fromObject: { ...queryParams, wall: id }});
    return this.httpService.get('social-posts', params);
  }

  public sendSocialWallPost(data: Partial<SocialWallPostModel>): Observable<SocialWallPostModel> {
    return this.httpService.post('social-post', data);
  }

  public likeSocialWallPost(id: string): Observable<void> {
    return this.httpService.post(`like/node/${id}`, null);
  }

  public likeSocialWallComment(id: string): Observable<void> {
    return this.httpService.post(`like/comment/${id}`, null);
  }

  public removeLikeSocialWallPost(id: string): Observable<void> {
    return this.httpService.post(`unlike/node/${id}`, null);
  }

  public removeLikeSocialWallComment(id: string): Observable<void> {
    return this.httpService.post(`unlike/comment/${id}`, null);
  }

  public patchSocialWallPostPin(id: string, pinned: boolean): Observable<void> {
    return this.httpService.patch(`social-post/${id}`, { id, pinned });
  }

  public createSocialWallComment(entityId: string, message: string, parentCommentId: string = ''): Observable<any> {
    return this.httpService.post('comments', { entityId, entityTypeId: 'node', message, parentCommentId });
  }

  public getSocialWallComments(entityId: string, limit = 10, offset = 0, parentCommentId: string = ''): Observable<DataResponse<any>> {
    const params = new HttpParams()
      .set('offset', offset.toString())
      .set('limit', limit.toString())
      .set('sort', 'created:DESC')
      .set('parentCommentId', parentCommentId);

    return this.httpService.get(`comments/node/${entityId}`, params);
  }

}
